import React, { useState, useEffect } from 'react';
import usflag from '../../assets/images/usflag.png';

const ACCENT_THEME_CLASSES = {
  default: {
    text: "text-[#7C3A8D]",
    bg: "bg-[#FFE6D1]",
  },
  brand: {
    text: "text-[#9A2E1A]",
    bg: "bg-[#F3E2DB]",
  },
};

const NotificationCarouselHairStyle = ({ accentTheme = "default", isBodytype = false }) => {
  const accentClasses =
    ACCENT_THEME_CLASSES[accentTheme] || ACCENT_THEME_CLASSES.default;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isDropping, setIsDropping] = useState(false);

  // Random women names
  const womenNames = [
    'Emma', 'Olivia', 'Ava', 'Isabella', 'Sophia', 'Charlotte', 'Mia', 'Amelia',
    'Harper', 'Evelyn', 'Abigail', 'Emily', 'Elizabeth', 'Mila', 'Ella', 'Avery',
    'Sofia', 'Camila', 'Aria', 'Scarlett', 'Victoria', 'Madison', 'Luna', 'Grace',
    'Chloe', 'Penelope', 'Layla', 'Riley', 'Zoey', 'Nora', 'Lily', 'Eleanor',
    'Hannah', 'Lillian', 'Addison', 'Aubrey', 'Ellie', 'Stella', 'Natalie', 'Zoe'
  ];

  // Hairstyle values
  const hairstyleValues = [
    'Soft Volume',
    'Polished Sleek',
    'Textured Chic',
    'Face-Framing',
    'Modern Classic',
    'Effortless Waves',
    'Bold Layers',
    'Clean & Sharp',
    'Romantic Flow',
    'Edgy Texture'
  ];

  const kibbeValues = [
    'Dramatic',
    'Soft Dramatic',
    'Flamboyant Natural',
    'Natural',
    'Soft Natural',
    'Dramatic Classic',
    'Classic',
    'Soft Classic',
    'Flamboyant Gamine',
    'Gamine',
    'Soft Gamine',
    'Theatrical Romantic',
    'Romantic'
  ];

  // Generate 20 different notifications
  const generateNotifications = () => {
    const notifications = [];
    for (let i = 0; i < 20; i++) {
      const randomName = womenNames[Math.floor(Math.random() * womenNames.length)];
      const valuesPool = isBodytype ? kibbeValues : hairstyleValues;
      const randomStyle = valuesPool[Math.floor(Math.random() * valuesPool.length)];
      
      notifications.push({
        id: i,
        name: randomName,
        style: randomStyle
      });
    }
    return notifications;
  };

  const [notifications] = useState(generateNotifications());

  useEffect(() => {
    // Simple interval approach - change item every 5 seconds for testing
    const intervalId = setInterval(() => {
      console.log('Changing item at:', new Date().toLocaleTimeString());
      
      // Trigger slide-up animation
      setIsVisible(false);
      
      // After slide-up, change notification
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % notifications.length);
        setIsDropping(true);
        setIsVisible(true);
        
        // Reset dropping state
        setTimeout(() => {
          setIsDropping(false);
        }, 500);
      }, 300);
    }, 5000); // Fixed 5 seconds for testing

    // Cleanup
    return () => {
      clearInterval(intervalId);
    };
  }, [notifications.length]);

  const currentNotification = notifications[currentIndex];

  return (
    <div className="py-2 w-full overflow-hidden">
      <div className="flex items-center justify-center">
        <div 
          className={`flex items-center transition-all duration-500 ease-in-out ${
            isVisible 
              ? isDropping 
                ? 'opacity-100 transform translate-y-0 animate-bounce' 
                : 'opacity-100 transform translate-y-0'
              : 'opacity-0 transform -translate-y-4'
          }`}
        >
          <div className="text-xs text-[#6B7280] flex items-center font-['Inter',system-ui,-apple-system,sans-serif] whitespace-nowrap">
            <span className={`font-semibold ${accentClasses.text}`}>{currentNotification.name}</span>
            <span className="mx-1 text-[#6B7280]">Just Bought her Analysis!</span>
            <img 
              src={usflag} 
              alt="US Flag" 
              className="w-4 h-3 mx-1 rounded-sm object-cover shadow-sm"
            />
            <span className="text-[#6B7280] mr-1">{isBodytype ? 'She was' : 'She has'}</span>
            <span className={`font-bold ${accentClasses.text} ${accentClasses.bg} px-1 py-0.5 rounded text-xs`}>{currentNotification.style}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationCarouselHairStyle;
